import { useQuery } from '@tanstack/react-query';
import { policyTransactionService } from '../../../services/policy-transaction.service';

export function usePolicyTransactionsByNumber(policyNumber, enabled = false) {
  return useQuery({
    queryKey: ['policy-transactions', policyNumber],
    queryFn: () => policyTransactionService.getPolicyTransactionsByNumber(policyNumber),
    enabled: enabled && !!policyNumber, // Only fetch when enabled and policyNumber exists
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
}
